import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyPesos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCurrencyPesos"><Path d="M20.5 10.5H3.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M20.5 6.5H3.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M6.5 21.5V2.5H12.4578C15.755 2.5 18.4345 5.1607 18.4576 8.4579C18.481 11.788 15.7879 14.5 12.4578 14.5H7" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCurrencyPesos;
